/** @module Quality/FactoryReviewForm */
define([
    "dojo/_base/declare",
    "Operations/ReviewForm"
], function(declare,ReviewForm) {

    return declare(ReviewForm, {

        ownerNodeType : "Factory"

    });
 });
